import React, { useContext, useEffect, useState, useRef, useMemo } from 'react'
import Modal from 'react-bootstrap/Modal';
import { AuthContext } from '../../../component/context/AuthContext';
import axios from 'axios';
import { GET_EMP_BY_ID, HOST } from '../../../component/config/Constant';
import * as CONST from "../../../component/config/Constant";
import { toast } from 'react-toastify';
import DivSpinner from '../../../component/utilities/Spinner';
import { Link } from "react-router-dom";
import moment from 'moment';
import Swal from 'sweetalert2';
import fileIcon from "../../../assets/img/icon/file.png";
import JoditEditor from 'jodit-react';
import '../employee/employee-details.css';
function ModalViewResignation({ closeResignationModal, resignationData }) {
  const [authUserData] = useContext(AuthContext);
  const [show] = useState(true);
  const [loading, setLoading] = useState(false);
  const [empDetails, setEmpDetails] = useState(null);
  const [resignationDetails, setResignationDetails] = useState(null);
  const [approvalComment, setApprovalComment] = useState("");
  const [processing, setProcessing] = useState(false);
  const [noticePeriod, setNoticePeriod] = useState("");
  const [releaseDate, setReleaseDate] = useState("");
  const displayDate = moment(releaseDate).format("DD MMM YYYY");
  const [errors, setErrors] = useState({});

  const remarkEditor = useRef(null);
  const remarkConfig = useMemo(() => ({
    readonly: false,
    uploader: { insertImageAsBase64URI: true },
    toolbarButtonSize: 'small',
    toolbarSticky: false,
    buttons: ["bold", "italic", "underline", "|", "ul", "ol", "|", "undo", "redo"],
    height: 150,
  }), []);

  let isToken = "";
  let user_id = "";
  let hr_head = 0;
  if (authUserData && authUserData[0]) {
    isToken = authUserData[0].token || "";
    user_id = authUserData[0].user_id || "";
    hr_head = authUserData[0].hr_head || 0;

  }
  // 1. Determine the current step and status from fresh data if available, else props
  const activeStep =
    resignationDetails?.current_step || resignationData?.current_step;
  const activeStatus =
    resignationDetails?.final_status || resignationData?.final_status;

  // 2. Refined Permission Logic
  const isPending = activeStatus === "Pending";

  // Check if user is HR and it's an HR step (2 or 5)
  const isHRActing = hr_head == 1 && (activeStep === 2 || activeStep === 5);

  // Check if user is Accounts (Dept 9) and it's the Accounts step (4)
  // const isAccountsActing = department_id == 9 && activeStep === 4;

  // 3. Final Boolean for visibility
  // The hub shows if it's pending AND (the user is HR in an HR step OR the user is Accounts in an Accounts step)
  const showActionHub = isPending && isHRActing;
  const fetchDetails = async () => {
    setLoading(true);
    try {
      const empRes = await axios.post(
        GET_EMP_BY_ID,
        {
          id: user_id,
          user_id: resignationData.user_id,
        },
        {
          headers: { Authorization: `Bearer ${isToken}` },
        },
      );
      if (empRes.data.status === "success") setEmpDetails(empRes.data.data);

      const detailsRes = await axios.get(
        `${CONST.RESIGNATION_DETAILS}${resignationData.id}`,
        {
          headers: { Authorization: `Bearer ${isToken}` },
        },
      );
      if (detailsRes.data.status === "success")
        setResignationDetails(detailsRes.data.data);
    } catch (error) {
      toast.error("Error fetching details.");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  // Auto-populate notice period from designation when empDetails loads
  useEffect(() => {
    if (empDetails?.designation?.notice_period && !noticePeriod) {
      setNoticePeriod(empDetails.designation.notice_period.toString());
    }
  }, [empDetails]);

  useEffect(() => {
    if (resignationData?.applied_date && noticePeriod) {
      const appliedDate = moment(resignationData.applied_date);
      // Add the notice period days to the applied date
      const calculatedDate = appliedDate.add(parseInt(noticePeriod), "days");

      // Set the state for the release date input
      setReleaseDate(calculatedDate.format("YYYY-MM-DD"));
    }
  }, [noticePeriod, resignationData?.applied_date]);

  const handleAction = async (action) => {
    setErrors({});
    const validationErrors = {};

    // 1. Comment Validation (General) — strip HTML tags for empty check
    const plainComment = approvalComment ? approvalComment.replace(/<[^>]*>/g, '').trim() : '';
    if (!plainComment) {
      validationErrors.approvalComment = action === "Info Requested"
        ? "Please describe what information you need."
        : "Please provide a comment.";
    }

    // 2. Find the current pending step
    const pendingStep = resignationDetails?.workflows?.find(
      (w) => w.status === "Pending",
    );

    if (!pendingStep) {
      toast.error("No pending step found for this resignation."); // Keep as toast; this is a system error
      return;
    }

    // --- 3. INLINE VALIDATION FOR STEP 2 ---
    if (action === "Approved" && pendingStep.step_number === 2) {
      if (!noticePeriod || noticePeriod === "") {
        validationErrors.noticePeriod = "Notice Period is required.";
      } else if (parseInt(noticePeriod) <= 0) {
        validationErrors.noticePeriod =
          "Notice Period must be a positive number.";
      }

      if (!releaseDate || releaseDate === "") {
        validationErrors.releaseDate = "Release Date is required.";
      } else {
        const appliedDate = new Date(resignationData?.applied_date);
        const selectedReleaseDate = new Date(releaseDate);
        appliedDate.setHours(0, 0, 0, 0);
        selectedReleaseDate.setHours(0, 0, 0, 0);

        if (selectedReleaseDate <= appliedDate) {
          validationErrors.releaseDate =
            "Release Date must be later than Applied Date.";
        }
      }
    }
    // If there are validation errors, stop execution and show them inline
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    // 4. Proceed with Confirmation
    const actionLabels = {
      "Approved": { text: "approve", color: "#059669" },
      "Rejected": { text: "reject", color: "#dc2626" },
      "Info Requested": { text: "request additional information for", color: "#b45309" },
    };
    const label = actionLabels[action] || actionLabels["Approved"];

    Swal.fire({
      title: `Are you sure?`,
      text: `Do you want to ${label.text} this resignation?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: action === "Info Requested" ? "Yes, request info" : `Yes, ${action}!`,
      confirmButtonColor: label.color,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setProcessing(true);
        try {
          const response = await axios.post(
            CONST.RESIGNATION_PROCESS,
            {
              resignation_id: resignationData.id,
              step_number: pendingStep.step_number,
              action: action,
              comment: approvalComment,
              // Only send these values if we are on Step 2
              notice_period: pendingStep.step_number === 2 ? noticePeriod : null,
              release_date: pendingStep.step_number === 2 ? releaseDate : null,
            },
            {
              headers: { Authorization: `Bearer ${isToken}` },
            },
          );

          if (response.data.status === "success") {
            toast.success(`Resignation ${action} successfully.`);
            setApprovalComment("");
            fetchDetails();
          } else {
            toast.error(response.data.message);
          }
        } catch (error) {
          toast.error(error.response?.data?.message || "Server error during processing.");
        } finally {
          setProcessing(false);
        }
      }
    });
  };

  const handleDeleteComment = async (commentId) => {
    Swal.fire({
      title: "Delete Comment & Revert Step?",
      text: "Deleting this will move the resignation back to the previous step and remove this record permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete and revert!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true); // Start loader since backend is doing a transaction
        try {
          const response = await axios.delete(
            `${CONST.RESIGNATION_COMMENT_DELETE}/${commentId}`,
            {
              headers: {
                Authorization: `Bearer ${isToken}`,
              },
            },
          );

          if (response.data.status === "success") {
            Swal.fire({
              title: "Reverted!",
              text: "Comment deleted and workflow step reverted.",
              icon: "success",
              confirmButtonColor: "#0d6efd",
            });
            // Ensure this matches your fetch function name
            fetchDetails();
          } else {
            Swal.fire("Error", response.data.message, "error");
          }
        } catch (err) {
          Swal.fire("Error", err.response?.data?.message || "Failed to delete. Please try again.", "error");
        } finally {
          setLoading(false); // Stop loader
        }
      }
    });
  };

  const handleEditComment = async (commentObj) => {
    Swal.fire({
      title: "Edit Comment",
      input: "textarea",
      inputValue: commentObj.comment,
      showCancelButton: true,
      confirmButtonText: "Update",
      confirmButtonColor: "#0d6efd",

      didOpen: () => {
        // Manually force focus on the Swal input
        const input = Swal.getInput();
        if (input) {
          input.focus();
        }
      },
      preConfirm: (newComment) => {
        if (!newComment.trim()) {
          Swal.showValidationMessage("Comment cannot be empty");
        }
        return newComment;
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.put(
            `${CONST.RESIGNATION_COMMENT_EDIT}/${commentObj.id}`,
            { new_comment: result.value },
            { headers: { Authorization: `Bearer ${isToken}` } },
          );

          if (response.data.status === "success") {
            toast.success("Comment updated");
            fetchDetails();
          } else {
            toast.error(response.data.message);
          }
        } catch (err) {
          toast.error("Update failed");
        }
      }
    });
  };
  // All 5 steps — fill from DB, show "Upcoming" for missing ones
  const allStepNames = ["Applied", "HR Review", "IT Clearance", "Accounts Clearance", "HR Final Approval"];
  const dbWorkflows = [...(resignationDetails?.workflows || [])].sort(
    (a, b) => a.step_number - b.step_number
  );
  const workflows = allStepNames.map((name, i) => {
    const dbStep = dbWorkflows.find(w => w.step_number === i + 1);
    return dbStep || { id: `placeholder-${i}`, step_number: i + 1, step_name: name, status: "Upcoming" };
  });
  const totalSteps = workflows.length;
  let activeIndex = workflows.findIndex((w) => w.status === "Pending");
  if (activeIndex === -1) {
    activeIndex = workflows.findIndex((w) => w.status === "Upcoming") - 1;
    if (activeIndex < 0) activeIndex = workflows.length - 1;
  }
  const stepWidth = 100 / (totalSteps - 1);
  const lineWidth = activeIndex * stepWidth;

  return (
    <Modal
      show={show}
      onHide={() => closeResignationModal("hide")}
      fullscreen
      backdrop="static"
      contentClassName="border-0 rounded-0 h-100"
      dialogClassName="m-0 h-100 w-100"
    >
      <Modal.Header closeButton className="bg-white border-bottom px-4 py-3">
        <Modal.Title className="fw-bold text-dark d-flex align-items-center">
          <div className="bg-primary-subtle p-2 rounded-3 me-3 mr-3 text-primary">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <polyline points="10 9 9 9 8 9"></polyline>
            </svg>
          </div>
          Review Resignation Case: {resignationData?.user?.first_name}{" "}
          {resignationData?.user?.last_name}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ background: '#f8fafc', padding: 0 }}>
        {loading && (
          <div className="text-center py-5">
            <DivSpinner size="lg" color="primary" />
          </div>
        )}

        {!loading && (
          <div className="container-fluid p-4">
            <div className="row g-4">
              <div className="col-lg-4">
                <div className="card h-auto" style={{ borderRadius: 14, border: '1px solid #e2e8f0' }}>
                  {empDetails ? (
                    <div style={{ padding: '20px' }}>
                      {/* Profile Row */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 16 }}>
                        <div style={{ width: 56, height: 56, minWidth: 56, borderRadius: '50%', overflow: 'hidden', background: '#0f2847', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#7db3ff', fontWeight: 700, fontSize: '1rem' }}>
                          {empDetails?.profile_photo_path ? (
                            <img src={HOST + empDetails.profile_photo_path} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                          ) : (
                            <>{empDetails?.first_name?.[0]}{empDetails?.last_name?.[0]}</>
                          )}
                        </div>
                        <div>
                          <div style={{ fontWeight: 700, fontSize: '1rem', color: '#0a1628' }}>{empDetails?.first_name} {empDetails?.last_name}</div>
                          <div style={{ fontSize: '0.78rem', color: '#64748b' }}>{empDetails?.designation?.name} | {empDetails?.department?.name}</div>
                          <span style={{ background: '#f0f5ff', color: '#1167e8', padding: '2px 10px', borderRadius: 12, fontSize: '0.7rem', fontWeight: 600 }}>EMP-{empDetails?.id}</span>
                        </div>
                      </div>

                      {/* Info Grid */}
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', borderTop: '1px solid #e2e8f0', borderBottom: '1px solid #e2e8f0', padding: '14px 0' }}>
                        <div>
                          <div style={{ fontSize: '0.68rem', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', marginBottom: 2 }}>Applied On</div>
                          <div style={{ fontSize: '0.85rem', fontWeight: 600, color: '#0a1628' }}>{moment(resignationData?.applied_date).format("DD MMM YYYY")}</div>
                        </div>
                        <div>
                          <div style={{ fontSize: '0.68rem', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', marginBottom: 2 }}>Target Release</div>
                          <div style={{ fontSize: '0.85rem', fontWeight: 600, color: resignationData?.release_date ? '#059669' : '#d97706' }}>{resignationData?.release_date ? moment(resignationData.release_date).format("DD MMM YYYY") : "Not Set"}</div>
                        </div>
                        <div>
                          <div style={{ fontSize: '0.68rem', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', marginBottom: 2 }}>Date of Joining</div>
                          <div style={{ fontSize: '0.85rem', fontWeight: 600, color: '#0a1628' }}>{empDetails?.date_of_joining ? moment(empDetails.date_of_joining).format("DD MMM YYYY") : "N/A"}</div>
                        </div>
                        <div>
                          <div style={{ fontSize: '0.68rem', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', marginBottom: 2 }}>Experience</div>
                          <div style={{ fontSize: '0.85rem', fontWeight: 600, color: '#0a1628' }}>
                            {empDetails?.date_of_joining ? (() => { const y = moment().diff(moment(empDetails.date_of_joining), 'years'); const m = moment().diff(moment(empDetails.date_of_joining), 'months') % 12; return `${y}y ${m}m`; })() : "N/A"}
                          </div>
                        </div>
                      </div>

                      {/* Reason */}
                      <div style={{ paddingTop: 14 }}>
                        <div style={{ fontSize: '0.68rem', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', marginBottom: 6 }}>Reason for Resignation</div>
                        <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: '12px 14px', fontSize: '0.85rem', color: '#334155', lineHeight: 1.6 }}
                          dangerouslySetInnerHTML={{ __html: resignationData?.reason }} />
                      </div>

                      {/* Attachment */}
                      {(resignationDetails?.documents || resignationData?.documents) && (
                        <div style={{ paddingTop: 12 }}>
                          <div style={{ fontSize: '0.68rem', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', marginBottom: 6 }}>Attachment</div>
                          <Link
                            to={HOST + (resignationDetails?.documents || resignationData?.documents)}
                            target="_blank"
                            style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: '#f0f5ff', border: '1px solid #dbeafe', borderRadius: 8, padding: '8px 14px', fontSize: '0.82rem', color: '#1167e8', fontWeight: 600, textDecoration: 'none' }}
                          >
                            <img src={fileIcon} alt="Document" width={18} height={18} />
                            View Document
                          </Link>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="text-center p-4">
                      <DivSpinner size="sm" color="primary" />
                    </div>
                  )}
                </div>
              </div>

              {/* Right Column: Decisions & History */}
              <div className="col-lg-8">
                <div className="row g-4">
                  {/* Workflow Section */}
                  <div className="col-12 ">
                    <div className="card mt-3 p-4 bg-white" style={{ borderRadius: 14, border: '1px solid #e2e8f0' }}>
                      <h5 className="fw-bold mb-4 d-flex align-items-center text-dark">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="me-3"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2.5"
                        >
                          <circle cx="12" cy="12" r="10" />
                          <polyline points="12 8 12 12 14 14" />
                        </svg>

                        <span className="fw-bold text-dark ml-2">
                          Submission Lifecycle
                        </span>
                      </h5>

                      <div className="d-flex align-items-center w-100 mt-4">
                        {workflows.map((w, idx) => (
                          <React.Fragment key={w.id}>

                            {/* STEP */}
                            <div className="text-center d-flex flex-column align-items-center">

                              {/* Circle */}
                              <div className="d-flex align-items-center justify-content-center">
                                <div
                                  className="rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                  style={{
                                    width: 36, height: 36,
                                    background: w.status === "Approved" ? "#059669" : w.status === "Rejected" ? "#dc2626" : w.status === "Pending" ? "#1167e8" : "#e2e8f0",
                                    color: w.status === "Upcoming" ? "#94a3b8" : "#fff",
                                    border: w.status === "Upcoming" ? "2px solid #cbd5e1" : "3px solid #fff",
                                    fontSize: '0.8rem', fontWeight: 800,
                                  }}
                                >
                                  {w.status === "Approved"
                                    ? "✓"
                                    : w.status === "Rejected"
                                      ? "✗"
                                      : w.step_number}
                                </div>
                              </div>

                              {/* Label */}
                              <div className="small fw-bold mt-2 text-dark text-uppercase" style={{ fontSize: '0.7rem', color: '#64748b' }}>
                                {w.step_name}
                              </div>

                              {/* Badge */}
                              {w.step_name !== "Applied" && (
                                <div
                                  className={`db-status-badge ${w.status === "Approved"
                                      ? "db-badge-success"
                                      : w.status === "Rejected"
                                        ? "db-badge-danger"
                                        : w.status === "Pending"
                                          ? "db-badge-warning"
                                          : "db-badge-light"
                                    } ${w.status === "Upcoming" ? "db-badge-muted" : ""}`}
                                  style={{ fontSize: "0.55rem" }}
                                >
                                  {w.status}
                                </div>
                              )}
                            </div>

                            {/* LINE BETWEEN STEPS */}
                            {idx !== workflows.length - 1 && (
                              <div
                                className="flex-grow-1 mx-1"
                                style={{
                                  height: 3,
                                  backgroundColor: idx < activeIndex ? "#059669" : idx === activeIndex ? "#1167e8" : "#e2e8f0",
                                  alignSelf: "center",
                                  position: "relative",
                                  top: "-9px"
                                }}
                              ></div>
                            )}

                          </React.Fragment>
                        ))}
                      </div>

                    </div>
                  </div>

                  {/* Approval Actions */}
                  {showActionHub && (
                    <div className="col-12">
                      <div className="card p-4 bg-white" style={{ borderRadius: 14, border: '1px solid #e2e8f0' }}>
                        <h5 className="fw-bold mb-3 text-dark">
                          Management Action Hub
                        </h5>

                        <div className="row">
                          {/* Step 2 specific fields */}
                          {activeStep === 2 && (
                            <>
                              <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold small text-muted">
                                  Notice Period (Days)
                                </label>
                                <input
                                  type="number"
                                  className={`form-control ${errors.noticePeriod ? "is-invalid" : ""}`}
                                  style={
                                    errors.noticePeriod
                                      ? {
                                        backgroundPosition:
                                          "right 2.6rem center",
                                      }
                                      : {}
                                  }
                                  min={0}
                                  value={noticePeriod}
                                  onChange={(e) =>
                                    setNoticePeriod(e.target.value)
                                  }
                                  placeholder="e.g. 30"
                                />
                                {errors.noticePeriod && (
                                  <div className="invalid-feedback">
                                    {errors.noticePeriod}
                                  </div>
                                )}
                              </div>

                              <div className="col-md-6 mb-3">
                                <label className="form-label fw-bold small text-muted">
                                  Final Release Date (Auto-calculated)
                                </label>
                                <input
                                  type="date"
                                  className={`form-control ${errors.releaseDate ? "is-invalid" : ""}`}
                                  style={
                                    errors.releaseDate
                                      ? {
                                        backgroundPosition:
                                          "right 2.6rem center",
                                      }
                                      : {}
                                  }
                                  value={releaseDate}
                                  onChange={(e) =>
                                    setReleaseDate(e.target.value)
                                  }
                                />
                                {errors.releaseDate && (
                                  <div className="invalid-feedback">
                                    {errors.releaseDate}
                                  </div>
                                )}
                              </div>
                            </>
                          )}

                          {/* General Feedback/Remark field — rich text */}
                          <div className="col-12 mb-4">
                            <label className="form-label fw-bold small text-muted">
                              Final Review Remark / Feedback
                            </label>
                            <JoditEditor
                              ref={remarkEditor}
                              config={remarkConfig}
                              value={approvalComment}
                              onBlur={(newContent) => setApprovalComment(newContent)}
                              onChange={(newContent) => setApprovalComment(newContent)}
                            />
                            {errors.approvalComment && (
                              <div className="invalid-feedback d-block">
                                {errors.approvalComment}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="d-flex justify-content-center align-items-center gap-2">
                          <button
                            className="btn btn-md px-4 mr-2"
                            style={{ background: '#059669', color: '#fff', borderRadius: 8, fontWeight: 600 }}
                            onClick={() => handleAction("Approved")}
                            disabled={processing}
                          >
                            {processing ? "Processing..." : "Approve"}
                          </button>
                          <button
                            className="btn btn-md px-4 mr-2"
                            style={{ background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 8, fontWeight: 600 }}
                            onClick={() => handleAction("Rejected")}
                            disabled={processing}
                          >
                            Reject
                          </button>
                          <button
                            className="btn btn-md px-4"
                            style={{ background: '#fffbeb', color: '#b45309', border: '1px solid #fde68a', borderRadius: 8, fontWeight: 600 }}
                            onClick={() => handleAction("Info Requested")}
                            disabled={processing}
                          >
                            Request Info
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Comment Trail
                  <div className="col-12">
                    <div
                      className="card border shadow-sm rounded-4 p-4 bg-white overflow-auto"
                      style={{ maxHeight: "300px" }}
                    >
                      <h5 className="fw-bold mb-4 text-dark">
                        Audit Log & Decision History
                      </h5>

                      {resignationDetails?.comments?.length > 0 ? (
                        resignationDetails.comments.map((c) => (
                          <div
                            key={c.id}
                            className="d-flex mb-3 p-3 rounded-4 bg-light border"
                          >
                            <div className="me-3 mr-3">
                              <div
                                className="rounded-circle d-flex align-items-center justify-content-center text-white shadow-sm bg-primary"
                                style={{ width: 32, height: 32 }}
                              >
                                {c.commenter?.first_name?.[0]}
                              </div>
                            </div>

                            <div className="flex-fill">
                              <div className="d-flex justify-content-between align-items-center">
                                <span className="fw-bold small text-dark">
                                  {c.commenter?.first_name}{" "}
                                  {c.commenter?.last_name}
                                </span>
                                <span
                                  className="text-muted"
                                  style={{ fontSize: "0.7rem" }}
                                >
                                  {moment(c.created_at).format("MMM DD, HH:mm")}
                                </span>
                              </div>

                              <div className="mt-1">
                                <span
                                  className={`badge py-1 px-2 mb-2 ${
                                    c.action === "Approved"
                                      ? "bg-primary text-white"
                                      : c.action === "Rejected"
                                        ? "bg-danger text-white"
                                        : "bg-secondary text-white"
                                  }`}
                                  style={{ fontSize: "0.6rem" }}
                                >
                                  {c.action}
                                </span>

                                <p className="mb-0 text-muted small">
                                  {c.comment || "No comment provided."}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center py-4 bg-light rounded-4">
                          <p className="text-muted small mb-0">
                            No official remarks recorded yet.
                          </p>
                        </div>
                      )}
                    </div>
                  </div> */}
                  {/* Comment Trail - Tabular Format */}
                  <div className="col-12">
                    <div className="card border shadow-sm rounded-4 p-4 bg-white">
                      <h5 className="fw-bold mb-4 text-dark d-flex align-items-center">
                        Audit Log & Decision History
                      </h5>

                      <div className="table-responsive">
                        <table style={{ width: '100%', fontSize: '0.85rem', borderCollapse: 'collapse' }}>
                          <thead>
                            <tr>
                              {['Name', 'Comment', 'Attachment', 'Date', 'Status', 'Actions'].map(h => (
                                <td key={h} style={{ fontSize: '0.72rem', fontWeight: 700, color: '#334155', textTransform: 'uppercase', padding: '10px 14px', background: '#f1f5f9', borderBottom: '2px solid #e2e8f0', letterSpacing: '0.04em' }}>{h}</td>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {resignationDetails?.comments?.length > 0 ? (
                              [...resignationDetails.comments]
                                .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                                .map((c, index, sortedArray) => {
                                  const isLastComment = index === 0;
                                  const isOwner = String(c.commented_by) === String(user_id);
                                  const actionStyle = {
                                    "Approved": { bg: '#ecfdf5', color: '#059669' },
                                    "Rejected": { bg: '#fef2f2', color: '#dc2626' },
                                    "Info Requested": { bg: '#fff7ed', color: '#c2410c' },
                                    "Info Provided": { bg: '#f0f9ff', color: '#0369a1' },
                                    "Withdrawn": { bg: '#f1f5f9', color: '#64748b' },
                                  }[c.action] || { bg: '#f1f5f9', color: '#64748b' };

                                  return (
                                    <tr key={c.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                      <td style={{ padding: '10px 14px', fontWeight: 600, color: '#0a1628' }}>{c.commenter?.first_name} {c.commenter?.last_name}</td>
                                      <td style={{ padding: '10px 14px', color: '#334155', maxWidth: 300 }} dangerouslySetInnerHTML={{ __html: c.comment || "—" }} />
                                      <td style={{ padding: '10px 14px' }}>
                                        {c.attachment ? (
                                          <a href={HOST + c.attachment} target="_blank" rel="noreferrer" style={{ fontSize: '0.78rem', color: '#1167e8', fontWeight: 600, textDecoration: 'none' }}>View File</a>
                                        ) : <span style={{ color: '#94a3b8' }}>—</span>}
                                      </td>
                                      <td style={{ padding: '10px 14px', color: '#64748b', whiteSpace: 'nowrap' }}>{moment(c.created_at).format("DD MMM YYYY, hh:mm A")}</td>
                                      <td style={{ padding: '10px 14px' }}>
                                        <span style={{ background: actionStyle.bg, color: actionStyle.color, padding: '3px 10px', borderRadius: 12, fontSize: '0.72rem', fontWeight: 600 }}>{c.action}</span>
                                      </td>
                                      <td style={{ padding: '10px 14px' }}>
                                        <div style={{ display: 'flex', gap: 4 }}>
                                          <button className="btn btn-sm btn-link text-secondary border-0 p-0" onClick={() => handleEditComment(c)}
                                            disabled={!isLastComment || !isOwner} title={!isLastComment ? "Only latest can be edited" : ""} style={{ opacity: isLastComment && isOwner ? 1 : 0.3 }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" /></svg>
                                          </button>
                                          <button className="btn btn-sm btn-link text-secondary border-0 p-0" onClick={() => handleDeleteComment(c.id)}
                                            disabled={!isLastComment || !isOwner} title={!isLastComment ? "Only latest can be deleted" : ""} style={{ opacity: isLastComment && isOwner ? 1 : 0.3 }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })
                            ) : (
                              <tr>
                                <td colSpan="6" style={{ textAlign: 'center', padding: '20px', color: '#94a3b8', fontSize: '0.85rem' }}>No official remarks recorded yet.</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default ModalViewResignation;
